import { ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';

import { ModelBoardPurchaseInterface } from '../interfaces/model-board-purchase.interface';
import { ModelBoardFloorDto } from '../../model-board-floor/dto/model-board-floor.dto';

@Exclude()
export class ModelBoardPurchaseDto implements ModelBoardPurchaseInterface {
  @ApiPropertyOptional({
    type: () => [ModelBoardFloorDto],
    title: 'Associated Board Floors',
    description: 'The floor boards received associated with model',
  })
  @Expose()
  modelBoardFloors?: ModelBoardFloorDto[];
}
